export { CANONICAL_MARKET, SUPPORTED_MARKETS } from './types'
export type { Market, MarketVariants, SiteVariants } from './types'
export { useSlideCopy } from './useSlideCopy'
export { useUi, uiStrings } from './ui'
export type { UiStrings } from './ui'

import { CANONICAL_MARKET, type Market } from './types'

/** ScamDefense is US-only. Provided for source-compat with forked slides. */
export function useUserMarket(): Market {
  return CANONICAL_MARKET
}
